import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { Protocol } from 'src/app/shared/interfaces/holidays.interface';
import { TruncatePipe } from 'src/app/shared/pipes/truncate.pipe';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';

@Component({
  selector: 'app-protocol-card',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    TruncatePipe,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './protocol-card.component.html',
  styleUrls: ['./protocol-card.component.css', '../../../styles/layout.css'],
})
export class ProtocolCardComponent {
  // input signal coming from the parent
  readonly protocol = input<Protocol | null>();
  readonly ruleGroupCount = input<number>(0);
  readonly operativaCount = input<number>(0);

  // output event for when a protocol is copied
  readonly protocolCopied = output<void>();

  constructor(
    private router: Router,
    private holidaysService: HolidaysService
  ) {}

  goToProtocol() {
    const proto = this.protocol();
    if (!proto?.id) return;

    // Navigate to protocol edit page in protocols context
    this.router.navigate([
      '/home/vacations/protocols/protocol',
      proto.id,
      'edit',
    ]);
  }

  copyProtocol(event: Event) {
    event.stopPropagation();
    const proto = this.protocol();
    if (!proto?.id) return;

    this.holidaysService.copyProtocol(proto.id).subscribe({
      next: () => {
        // Emit event to parent to reload the protocol list
        this.protocolCopied.emit();
      },
    });
  }
}
